import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { authSlice } from './auth';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { menuSlice } from './menu';
import { datalistsSlice } from './datalist';
import { dapvApi } from 'services';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['authentication']
};

const rootReducer = combineReducers({
    authentication: authSlice.reducer,
    datalists: datalistsSlice.reducer,
    menu: menuSlice.reducer,
    [dapvApi.reducerPath]: dapvApi.reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        }).concat(dapvApi.middleware)
});

export type AppStore = typeof store;

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
